import type { AdminOracordEnginePairingCodeResponse } from '@oracord/shared';
import { apiFetch } from './api';

export async function requestOracordEnginePairingCode(): Promise<AdminOracordEnginePairingCodeResponse> {
  return apiFetch<AdminOracordEnginePairingCodeResponse>('/api/admin/settings/oracord-engine/pairing-code', {
    method: 'POST',
  });
}
